<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!assistanceserviceSelected) {
        <h1 class="title">Crear {{ termKey.AccompanimentServiceSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (assistanceserviceSelected) {
        <h1 class="title">Editar {{ termKey.AccompanimentServiceSingular | term }}</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="assistanceserviceForm" (ngSubmit)="saveAssistanceserviceForm()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (assistanceserviceForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (assistanceserviceForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 150 caracteres
                </mat-error>
              }
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="componenteSelected"
                [initialValue]="getComponenteValue()"
                placeholder="Seleccione un componente"
                label="Componente"
                noResults="Sin resultados"
                (onSelectOption)="onComponentsSelected($event)"
              >
              </app-search-select>
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Ubicación:</mat-label>
              <mat-select formControlName="locations" multiple>
                <input
                  class="searchInput"
                  matInput
                  [formControl]="searchControl"
                  placeholder="Buscar ubicación"
                  oninput="this.value = this.value.toUpperCase()"
                />
                @for (
                  location of listLocation | searchfilter: searchControl.value;
                  track location.id
                ) {
                  <mat-option [value]="location.id">
                    {{ location.city }} - {{ location.department }}
                  </mat-option>
                }
              </mat-select>
              @if (assistanceserviceForm.get('locations')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Plan de vida:</mat-label>
              <mat-select formControlName="lifePlan" multiple>
                <input
                  class="searchInput"
                  matInput
                  [formControl]="searchControl"
                  placeholder="Buscar ubicación"
                  oninput="this.value = this.value.toUpperCase()"
                />
                @for (
                  lifePlan of listLifeplan | searchfilter: searchControl.value;
                  track lifePlan.id
                ) {
                  <mat-option [value]="lifePlan.id">
                    {{ lifePlan.name }}
                  </mat-option>
                }
              </mat-select>
              @if (assistanceserviceForm.get('lifePlan')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Territorio:</mat-label>
              <mat-select formControlName="territory" multiple>
                <input
                  class="searchInput"
                  matInput
                  [formControl]="searchControl"
                  placeholder="Buscar ubicación"
                  oninput="this.value = this.value.toUpperCase()"
                />
                @for (
                  territory of listTerritory | searchfilter: searchControl.value;
                  track territory.id
                ) {
                  <mat-option [value]="territory.id">
                    {{ territory.name }}
                  </mat-option>
                }
              </mat-select>
              @if (assistanceserviceForm.get('territory')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>
          </div>

          @if (fromList) {
            <div class="form-grid">
              <div class="search-select-container">
                <app-search-select
                  [dataList]="assistanceSelected"
                  [initialValue]="getassistanceValue()"
                  placeholder="Seleccione un valor"
                  label="{{ termKey.AssistanceSingular | term }}"
                  noResults="Sin resultados"
                  (onSelectOption)="onAssistenceSelected($event)"
                >
                </app-search-select>
              </div>
            </div>
          }
        </div>
        <button type="submit" class="primary-button" [disabled]="!assistanceserviceForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
